import styled from 'styled-components';
import colors from '@theme/colors';
import media from '@theme/media';
import FlexContainer from './FlexContainer';

export const DashboardFiltersWrapper = styled(FlexContainer).attrs({
  inline: true,
  gap: '5px',
})`
  font-size: 12px;
  button {
    background-color: ${colors.TEAL_LIGHT};
  }
  ${media.small} {
    flex-direction: column;
    align-items: flex-start;
    padding-left: 10px;
    button {
      margin-left: 5px;
    }
  }
`;



// WEBPACK FOOTER //
// ./components/layout/DashboardFilters.js